import React from 'react';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import TestDriveDevSidebar from './TestDriveDevSidebar';
const TD_INTRO_HELP = `
  <div>
    <p><strong>Purpose: </strong>A Test-drive is where you try out a particular access method setup, to see if it might be a good fit for you.
    Each Test-drive includes one or more activities, and afterward you’ll rate how things went.  
    So these are short-term trials, sort of like when you test-drive a car that you are considering buying.   
    </p>
    <p>
    If you want to try multiple access method setups, do a separate Test-drive with each one. Then you can compare the results as a way of informing the next steps to take. 
    For example, maybe you are comparing different types of head tracking devices. Each different device would be a different Test-drive. 
    </p>
    <p>
    Of course, you can certainly do longer-term trials as a next step after this assessment.  
    We hope that the Test-drives will help you narrow down the options so that you make the best use of your time when doing longer-term trials. 
    </p>
  </div>
`

const propTypes = {
  firstName: PropTypes.string,
};

const defaultProps = {
  firstName: 'the client',
};

//content sub-component with unique content for this page
function TestDriveIntroContent() {
  return(
    <>
    <p>Here's what we'll cover:</p>
    <ul>
      <li>Choose an access method to try</li>
      <li>Try it out, either using one of our activities or one of your choosing</li>
      <li>Rate how things went</li>
      <li>Decide on next steps</li>
    </ul>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function TestDriveIntro(props) {
  const firstName = props.firstName;
  const isFirstRouteActive = props.isFirstRouteActive;
  const dev = props.dev || {};
  const nextRoute = isFirstRouteActive ? "/test-drive/choose/first" : "/test-drive/choose/access-method";
  const pageData = {
    image: "./assets/images/target-icon.jpg",
    faIcon: "",
    pageSectionClassName: "main-section test-drive",
    majorHeading: "Test-drive Solutions",
    title: `We're ready to explore and test-drive solutions!`,
    subTitle: `Good news! Now that we've got a better understanding of ${firstName}'s situation, we can start exploring solutions.`,
    learnMore: {linkText: "Learn More about doing Test-drives",
                title: "Test-drives",
                content: TD_INTRO_HELP
                },
    nextRoute: nextRoute, //static name for next page
    sidebar: false
  }

  console.log("Rendering TestDriveIntro: isFirstRouteActive: " + isFirstRouteActive);
  
  return(
    <>
    <Body page={pageData} 
      contentComponent={<TestDriveIntroContent />} 
      sidebarComponent={
        dev.showDevSidebar 
        &&
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
        />  
      }
    />
    </>
  );
}

TestDriveIntro.propTypes = propTypes;
TestDriveIntro.defaultProps = defaultProps;

export default TestDriveIntro;